module.exports = "img/f-ciencias.552916.jpeg";